<template>
    <div>
        <section class="section has-background-primary has-text-centered">
            <br><br>
            <div class="container">
                <br>
                <h1 class="title has-text-white">Our story</h1>
                <p class="subtitle is-6 has-text-white">Steeped in real estate and home loan origination, our founding shareholders believed the real estate industry is in desperate need of change because traditional estate agents in South Africa are unable to look after buyers' and sellers' best interests simultaneously.</p>
                <p class="has-text-white">Many global innovators like Uber and Amazon have forever changed the customer experience<br><strong class="has-text-weight-bold has-text-white">- so why not real estate?</strong></p>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="columns is-vcentered">
                    <div class="column">
                        <h3 class="title is-5">Why we changed the local real estate industry</h3>
                        <ul class="ul-bullets">
                            <li>We researched real estate sales practice in the USA and the UK, where sellers and buyers are not represented by the same person or agent.</li>
                            <li>We studied what is important to sellers, buyers and agents in South Africa.</li>
                            <li>We adapted existing technologies and tools to help you make the right decisions and make your selling experience simple.</li>
                        </ul>
                        <br><br>
                        <h3 class="title is-5">What does this mean for you as a seller?</h3>
                        <ul class="ul-bullets">
                            <li>You finally have an estate agent that looks <strong>solely</strong> after you, the seller.</li>
                            <li>You get the best buyers through NestEgg's Partner Buyer Agents.</li>
                        </ul>
                    </div>

                    <div class="column">
                        <figure class="image">
                            <img alt="Aerial view of houses" id="aerial-view" src="../assets/images/about_us/aerial_view.svg">
                        </figure>
                    </div>
                </div>
            </div>
        </section>

        <section class="section has-background-light-blue">
            <div class="container has-text-centered">
                <h3 class="title">We give you the very best opportunity to sell at the highest price as fast as possible.</h3>
                <router-link class="button is-primary" to="/sell-with-us">See how it works</router-link>
            </div>
        </section>

        <section class="section">
            <div class="container has-text-centered">
                <h2 class="title">Our values</h2>
                <br>
                <div class="columns">
                    <div class="column grey-column">
                        <img class="benefit-icon" alt="Integrity" src="../assets/images/about_us/integrity.svg">
                        <h4><strong>Integrity</strong></h4>
                        <p>We only represent you - our seller</p>
                        <br class="is-hidden-touch">
                        <hr class="red-line">
                        <p><em>"Real integrity is doing the right thing, knowing that nobody's going to know whether you did it or not."</em></p>
                        <p><strong><em>- Oprah Winfrey</em></strong></p>
                    </div>
                    <div class="column grey-column">
                        <img class="benefit-icon" alt="Transparency" src="../assets/images/about_us/transparency.svg">
                        <h4><strong>Transparency</strong></h4>
                        <p>All our agreements are simple and easy to understand</p>
                        <hr class="blue-line">
                        <p><em>"Honesty is the first chapter of the book of wisdom."</em></p>
                        <p><strong><em>- Thomas Jefferson</em></strong></p>
                    </div>
                    <div class="column grey-column">
                        <img class="benefit-icon" alt="Customer Service" src="../assets/images/about_us/customer_service.svg">
                        <h4><strong>Customer Service</strong></h4>
                        <p>Our processes and technology are built to give you control</p>
                        <hr class="yellow-line">
                        <p><em>"I've learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel."</em></p>
                        <p><strong><em>- Maya Angelou</em></strong></p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <h2 class="title is-4 has-text-centered">Welcome to NestEgg from our principal</h2>
                <br>
                <div class="columns is-vcentered">
                    <div class="column">
                            <img alt="Helen Hoekstra" src="../../public/img/helen_600.jpg">
                    </div>
                    <div class="column">
                        <p>Having been in the industry for nearly 18 years, I began to question why so much time and effort is spent in helping buyers find their dream home, whereas so little effort is spent on our sellers. What I have learned is just <strong>how stressful selling a home can be</strong> - and <strong>how sellers often feel that no one is looking after their interests.</strong></p>
                        <br>
                        <p>As a seller, you entrust agents with the sale of your biggest asset, but often don’t get the feedback or essential advice you need, as traditional agents try to serve buyers and sellers at the same time.</p>
                        <br>
                        <p>I recognised this conflict and with NestEgg, by innovating and using the best technology available, we have simplified real estate to <strong>represent you the seller.</strong></p>
                        <br>
                        <p>Together, with my team of professionals, I am here to make a difference to your home sale experience.</p>
                        <br>
                        <p>Contact me directly at <a href="mailto:helen@mynestegg.co.za"><strong>helen@mynestegg.co.za</strong></a></p>
                        <br>
                        <p>Helen Hoekstra</p>
                        <br>
                        <router-link class="lined-up" to="/nestegg-downloads#ffc">
                            <img alt="FFC Icon" class="unpadded" width="55" src="../assets/images/about_us/ffc_icon.svg">
                            <strong>Click here to view our FFC Certificates</strong>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss">
    @import '../assets/sass/colours.scss';

    .red-line, .blue-line, .yellow-line {
        width: 35%;
        margin-left: auto;
        margin-right: auto;
    }

    .red-line {
        background-color: $orange;
    }

    .blue-line {
        background-color: $blue;
    }

    .yellow-line {
        background-color: $yellow;
    }

    .column a {
        color: $primary;
    }

    .lined-up {
        display: flex;
        align-items: center;

        img {
            margin-right: 1em;
        }
    }

    #aerial-view {
        max-width: 405px;
    }
</style>